import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const F = ({ label, testid, area, ...p }) => (
  <label className="block">
    <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#F5F1E8]/65">{label}</span>
    {area ? (
      <textarea {...p} data-testid={testid} rows={3} className="mt-1.5 w-full bg-transparent border border-white/15 p-3 outline-none focus:border-[#F59E0B] transition-colors resize-none" />
    ) : (
      <input {...p} data-testid={testid} className="mt-1.5 w-full bg-transparent border-b border-white/20 py-2.5 outline-none focus:border-[#F59E0B] transition-colors" />
    )}
  </label>
);

export const ConsultantDialog = ({ open, onOpenChange, audit }) => {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", company: audit?.company || "", email: user?.email || "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/consultant-requests", { ...form, audit_id: audit?.id });
      toast.success("Solicitud enviada. Un consultor de Ascentra te contactará pronto.");
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111722] border-white/10 rounded-none max-w-lg max-h-[90vh] overflow-y-auto" data-lenis-prevent data-testid="consultant-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold">Hablar con un consultor</DialogTitle>
          <DialogDescription className="text-[#F5F1E8]/70">Ascentra Consulting revisará tu auditoría y te contactará para cerrar las brechas detectadas.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 mt-2">
          <div className="grid sm:grid-cols-2 gap-5">
            <F label="Nombre" testid="consultant-name-input" value={form.name} onChange={set("name")} required minLength={2} />
            <F label="Empresa" testid="consultant-company-input" value={form.company} onChange={set("company")} required />
            <F label="Correo" testid="consultant-email-input" type="email" value={form.email} onChange={set("email")} required />
            <F label="Teléfono" testid="consultant-phone-input" type="tel" value={form.phone} onChange={set("phone")} required minLength={7} placeholder="81 1234 5678" />
          </div>
          <F label="Comentarios" testid="consultant-message-input" area value={form.message} onChange={set("message")} placeholder="¿Qué necesitas resolver primero?" />
          <button disabled={busy} data-testid="consultant-submit-button" className="w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-full bg-[#F59E0B] text-[#0B0F17] font-semibold hover:bg-[#F5F1E8] transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Enviar solicitud
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
